import { Card, Form } from '@deere/ux.uxframe-react'
import React from 'react'
import { getAnswerLabel,  getTranslation, findAnswerIndex } from '../../utils/utils'
import DateOfpReviewSection from '../review/DateOfpReviewSection'
import { QUESTION_PROPRIETARY } from '../../utils/surveyLiterals'
import PropiertaryInfReview from './PropiertaryInfReview'

export default function OfpReviewSection({ sectionSurvey, answers }) {

    if (!sectionSurvey)
        return <></>

    function createRow(q) {
        let  answer =  getAnswerLabel(q, answers);
        if(q.idQuestionDepends && (q.idQuestionDepends) > 0){//Is child question
            return answer === '-'?null:
                    <Form.Group className='mb-4 pl-4'>
                        <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                        <h6>{answer}</h6>
                    </Form.Group>
        }else{
            return <Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                        <h6>{answer}</h6>
                    </Form.Group>
        }
    }


    function createCheckRow(q) {
        let labels = getAnswerLabel(q, answers);
        labels = labels === '-' ? null : labels
        if(q.idQuestionDepends && (q.idQuestionDepends) > 0){
            return labels?<Form.Group className='mb-4 pl-4'>
                        <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                        {labels ? labels.map(lab => <li key={lab}>{lab}</li>) : ''}
                    </Form.Group>:null;
        }else{
            return labels?<Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                        {labels ? labels.map(lab => <li key={lab}>{lab}</li>) : ''}
                    </Form.Group>:null;
        }
    }

    const questions = sectionSurvey.questions.filter(qu => qu.active  && qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1)
    const propQuestion = sectionSurvey.questions.filter(qu => qu.active && qu.text === QUESTION_PROPRIETARY)[0];

    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, answers) >= 0 ? answers[findAnswerIndex(propQuestion.id, answers)].answer : '' : '';
    
    return (<div>{propComments? <PropiertaryInfReview section={sectionSurvey} answer={propComments}/>:null} 
                {!propComments?<Card>
            <Card.Body>
                <Card.Title className='pb-3'>
                    {getTranslation(sectionSurvey, 'description')}
                </Card.Title>
                {questions ? questions.map((q, idx) => <div key={idx}>
                    <Form.Row >
                        {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRow(q) : <></>}
                        {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRow(q) : <></>}
                        {q.type === 'CHECK' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCheckRow(q) : <></>}
                        {q.type === 'OPTION' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRow(q) : <></>}
                    </Form.Row>
                    {q.type === 'DATE_SECT' ? <DateOfpReviewSection ofpSection={sectionSurvey} dateQuestion={q} answers={answers} /> : <></>}
                </div>) : <></>}

            </Card.Body>
        </Card>:null
                }
        <br />
    </div>)
}